import { render, staticRenderFns } from "./Correspondencia.vue?vue&type=template&id=2d21e7d6&"
import script from "./Correspondencia.vue?vue&type=script&lang=js&"
export * from "./Correspondencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports